import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../Shared/Menu.css';
import './Login.css';
import logo from '../../images/audithippo.png';
import usePageTitle from '../Shared/usePageTitle';

const FORGOT_URL = '/rest/api/v1/admin/email/forgot-password';

function ForgotPassword() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [email, setEmail]       = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError]       = useState('');
    const [sent, setSent]         = useState(false);
    usePageTitle('Forgot Password');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!email.trim()) {
            setError('Please enter your email address.');
            return;
        }
        setSubmitting(true);
        try {
            await axios.post(FORGOT_URL, { email: email.trim() }, {
                headers: { 'Content-Type': 'application/json' },
            });
            setSent(true);
        } catch (err) {
            const data = err.response?.data;
            const msg = (data && (data.message || data.error)) || err.message || 'Unable to send reset email. Please try again.';
            setError(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className={`mobile-menu-overlay${menuOpen ? ' show' : ''}`} onClick={() => setMenuOpen(false)} />
            <div className={`mobile-menu${menuOpen ? ' show' : ''}`}>
                <div className="mobile-menu-header">
                    <a href="#" className="logobock d-flex align-items-center gap-2">
                        <div className="hippolog"><img src={logo} alt="AuditHippo" /></div>
                        <span className="brand-name">Audit<span className="hippotxt">Hippo</span></span>
                    </a>
                    <div className="mobile-menu-close" onClick={() => setMenuOpen(false)} role="button" aria-label="Close menu">✕</div>
                </div>
            </div>

            <nav className="navbar-custom">
                <div className="container-custom">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-3">
                            <button className="mobile-menu-btn" onClick={() => setMenuOpen(true)} aria-label="Open menu">
                                <span /><span /><span />
                            </button>
                            <div className="d-flex align-items-center gap-2">
                                <a href="#" className="logobock d-flex align-items-center gap-2">
                                    <div className="hippolog"><img src={logo} alt="AuditHippo" /></div>
                                    <span className="brand-name">Audit<span className="hippotxt">Hippo</span></span>
                                </a>
                                <span className="divider-mobile" />
                                <span className="marketing-cloud-text">Marketing Cloud</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <main className="container-main fade-up" style={{ maxWidth: 1200, margin: '0 auto' }}>
                <div className="page-header mb-4">
                    <h1>Forgot Password</h1>
                    <p>Enter your email and we'll send you a reset link</p>
                </div>

                <div className="login-screens-row" style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '100%', maxWidth: 520 }}>
                        <p className="login-screen-label">Password Reset</p>

                        <div className="login-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center gap-2 mb-4">
                                    <div className="logo-box">AH</div>
                                    <span className="brand-name">AuditHippo</span>
                                </div>

                                <span className="login-badge-user">Reset Access</span>

                                <h2 className="login-card-title">{sent ? 'Check your email' : 'Reset your password'}</h2>
                                <p className="login-card-subtitle">
                                    {sent
                                        ? `If an account exists for ${email.trim()}, a reset link is on its way. Click the link in the email to set a new password.`
                                        : 'Enter the email address associated with your AuditHippo account and we will send you a link to reset your password.'}
                                </p>

                                {!sent && (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <div className="mb-3">
                                            <label htmlFor="forgotEmail" className="login-label">Email</label>
                                            <input
                                                type="email"
                                                className="login-input"
                                                id="forgotEmail"
                                                placeholder="you@company.com"
                                                value={email}
                                                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                                autoComplete="email"
                                                disabled={submitting}
                                            />
                                        </div>

                                        {error && (
                                            <p style={{ color: '#DC2626', fontSize: 13, marginBottom: 12 }}>{error}</p>
                                        )}

                                        <button type="submit" className="login-primary-btn" disabled={submitting}>
                                            {submitting ? 'Sending…' : 'Send reset link'}
                                        </button>
                                    </form>
                                )}

                                <p className="login-footer-text mb-0" style={{ marginTop: 16 }}>
                                    Remembered your password? <Link to="/login" className="login-link">Back to sign in</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default ForgotPassword;
